import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import axios from 'axios';

// import Snackbar from "@/components/Snackbar.vue";
// Vue.prototype.$snackbar = Snackbar.methods.showSnackbar;

Vue.config.productionTip = false



window.axios = require('axios')
axios.defaults.baseURL = 'https://api.creativespacefurniture.com'
Vue.prototype.baseURL = "https://api.creativespacefurniture.com"
Vue.prototype.mediaURL = "https://api.creativespacefurniture.com/wp/"
Vue.prototype.mediaURLnew = "https://api.creativespacefurniture.com/wp"


// window.axios = require('axios')
// axios.defaults.baseURL = 'http://192.168.33.57:4501'
// Vue.prototype.baseURL = "http://192.168.33.57:4501"
// Vue.prototype.mediaURL = "http://192.168.33.57:4501/wp/"
// Vue.prototype.mediaURLnew = "http://192.168.33.57:4501/wp"

// window.axios = require('axios')
// axios.defaults.baseURL = 'http://192.168.58.5:4501'
// Vue.prototype.baseURL = "http://192.168.58.5:4501"
// Vue.prototype.mediaURL = "http://192.168.58.5:4501/wp/"
// Vue.prototype.mediaURLnew = "http://192.168.58.5:4501/wp"

// window.axios = require('axios')
// axios.defaults.baseURL = 'https://7wrb4ccq-4501.inc1.devtunnels.ms/'
// Vue.prototype.baseURL = "https://7wrb4ccq-4501.inc1.devtunnels.ms/"
// Vue.prototype.mediaURL = "https://7wrb4ccq-4501.inc1.devtunnels.ms//u/"
// Vue.prototype.mediaURLnew = "https://7wrb4ccq-4501.inc1.devtunnels.ms/wp/"

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
